import styled from 'styled-components';
import { Format, StyleColor, navBarHeight, BaseStyledComponentProps } from '../../../utils/styles-constants';
import { Button } from '../../../components/Button/styles';
import { Input } from '../../../components/Form/styles';
import { spin } from '../../../utils/style';

interface StyledSharePanelProps {
	isOpen: boolean;
}

const panelHeight = 470;
const panelHeightSmartphone = 800;
const statusBarHeight = 20;
const panelAndShadowHeightSmartphone = panelHeightSmartphone + 2 + statusBarHeight;

const StyledSharePanel = styled('div')`
	background-color: ${StyleColor.White};
	box-shadow: ${StyleColor.Grey300} 1px 1px 1px;
	height: ${panelHeight}px;
	width: 100%;
	position: absolute;
	top: ${(props: StyledSharePanelProps) => props.isOpen ? 0 : '-' + panelAndShadowHeightSmartphone}px;
	z-index: 15;
	transition: top 0.4s;
	/*
	panelAndShadowHeightSmartphone is used for the top property because of visual bug :
	the panel was appearing for 0.1s when resizing window width from 1200px to 1199px
	*/

	@media ${Format.Smartphone}, ${Format.Tablet}, ${Format.SmallDesktop} {
		top: ${(props: StyledSharePanelProps) => props.isOpen ? 0 : '-' + panelAndShadowHeightSmartphone}px;
		height: 100%;
		max-height:${panelHeightSmartphone}px;
	}

	@media print {
		${(props: StyledSharePanelProps) => props.isOpen ? 'top: 0' : 'display: none'};
	}
`;

const SharePanelHeader = styled('div')`
	height: ${navBarHeight};
	width: 100%;
	border-bottom: 1px solid ${StyleColor.Grey300};
`;

const SharePanelHeaderContainer = styled('div')`
	margin: 0 90px;
	height: 100%;
	display: flex;
	align-items: center;

	@media ${Format.Smartphone} {
		margin: 0 45px;
	}
`;

const SharePanelHeaderTitle = styled('span')`
	flex-grow: 1;
	font-size: 16px;
	font-weight: 600;
	color: ${StyleColor.Grey700};
`;

const SharePanelHeaderClose = styled('span')`
	font-size: 13px;
	color: ${(props: BaseStyledComponentProps) => props.theme.primary.actionColor};
	cursor: pointer;
	font-weight: regular;
`;

const SharePanelContent = styled('div')`
	height: 425px;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;

	-webkit-overflow-scrolling: touch;
	overflow-y: auto;
	overflow-x: hidden;

	@media ${Format.Smartphone}, ${Format.Tablet}, ${Format.SmallDesktop} {
		height: calc( 100% - 45px );
		max-height: 760px;
	}
`;

const SharePanelContentContainer = styled('div')`
	width: 1140px;
	height: 300px;
	display: flex;
	flex-direction: row;

	@media ${Format.Smartphone}, ${Format.Tablet}, ${Format.SmallDesktop} {
		flex-direction: column;
		align-self: flex-start;
		align-items: center;
		width: 100%;
		margin-top: 25px;
		margin-left: 35px;
		margin-right: 35px;
		width: calc(100% - 70px);
		max-width: 710px;
	}
`;

const SharePanelContentSelection = styled('div')`
	background-color: ${StyleColor.Grey50};
	padding: 35px 30px;
	width:360px;
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;

	@media ${Format.Smartphone}, ${Format.Tablet}, ${Format.SmallDesktop} {
		width: calc(100% - 60px);
	}
`;

const SharePanelContentSelectionTitle = styled('div')`
	text-transform: uppercase;
	font-size: 14px;
	font-weight: 600;
	color: ${StyleColor.Grey500};
	margin-bottom: 20px;
`;

const SharePanelContentSelectionContent = styled('div')`
	font-size: 14px;
	font-weight: 600;
	color: ${StyleColor.Grey800};
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
`;

const SharePanelContentRight = styled('div')`
	width: 710px;
	margin-left:30px;
	display: flex;
	flex-direction: column;

	@media ${Format.Smartphone}, ${Format.Tablet}, ${Format.SmallDesktop} {
		margin-left: 0;
		width: 100%;
	}
`;

const SharePanelContentRightMethods = styled('div')`
	min-height: 60px;
	display: flex;
	flex-direction: row;

	@media ${Format.Smartphone}, ${Format.Tablet}, ${Format.SmallDesktop} {
		margin-top: 20px;
		justify-content: space-around;
	}
	@media ${Format.Smartphone} {
		min-height: 35px;
	}
`;

const SharePanelContentForm = styled('div')`
	margin-top: 30px;

	@media ${Format.Smartphone}, ${Format.Tablet}, ${Format.SmallDesktop} {
		margin-top: 0;
	}
`;

const SharePanelContentFormTitle = styled('div')`
	margin-bottom: 20px;
	height: 20px;
	font-size: 16px;
	font-weight: 600;
	color: ${StyleColor.Grey700};

	@media ${Format.Smartphone}, ${Format.Tablet}, ${Format.SmallDesktop} {
		margin: 20px 0;
		font-size: 20px;
		font-weight: 400;
	}
`;

const SharePanelContentFormContent = styled('form')`
	display: flex;
	flex-direction: row;

	@media ${Format.Smartphone}, ${Format.Tablet}, ${Format.SmallDesktop} {
		flex-direction: column;
	}
`;

const SharePanelContentFormContentLeft = styled('div')`
	display: flex;
	flex-direction: column;
	width: 360px;

	@media ${Format.Smartphone}, ${Format.Tablet}, ${Format.SmallDesktop} {
		width: 100%;
	}
`;

const SharePanelContentFormContentRight = styled('div')`
	display: flex;
	flex-direction: column;
	width: 360px;
	margin-left: 30px;

	@media ${Format.Smartphone}, ${Format.Tablet}, ${Format.SmallDesktop} {
		margin-left: 0;
		width: 100%;
	}
`;


const ShareInput = styled(Input)`
	margin-bottom: 10px;
`;

const ShareInputLast = styled(Input)`
	margin-bottom: 0px;
`;

const ShareButton = styled(Button)`
	border-color: ${(props: BaseStyledComponentProps) => props.theme.primary.actionColor};
	background-color: ${(props: BaseStyledComponentProps) => props.theme.primary.actionColor};
	color: ${StyleColor.White};
	margin: 10px 0 0 0;
	max-height: 50px;

	@media (hover: hover) {
		&:hover {
			border-color: ${(props: BaseStyledComponentProps) => props.theme.primary.actionColor};
			background-color: ${(props: BaseStyledComponentProps) => props.theme.primary.actionColor};
			color: ${StyleColor.White};
		}
	}

	@media ${Format.Smartphone}, ${Format.Tablet}, ${Format.SmallDesktop} {
		align-self: center;
		width: 260px;
		max-width: 260px;
		height: 60px;
		margin: 25px 0;
	}

	&:disabled {
		color: ${StyleColor.Grey400};
		border-color: ${StyleColor.Grey400};
		background-color: transparent;
	}

	&:disabled svg {
		margin-left: 10px;
		width: 30px;
		height: 30px;
		animation: ${spin};
	}
`;

export { StyledSharePanelProps, StyledSharePanel, SharePanelHeader, SharePanelHeaderContainer, SharePanelHeaderTitle,
	SharePanelHeaderClose, SharePanelContent, SharePanelContentContainer, SharePanelContentSelection, SharePanelContentSelectionTitle,
	SharePanelContentSelectionContent, SharePanelContentRight, SharePanelContentRightMethods, SharePanelContentForm, SharePanelContentFormTitle,
	SharePanelContentFormContent, SharePanelContentFormContentLeft, SharePanelContentFormContentRight, ShareInput, ShareInputLast, ShareButton
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Share/WebpublicationForm/styles.ts